import React from 'react';
import NokiaLogo from 'components/NokiaLogo';
import { getContext } from 'common';
import Styled from './styles';

const LOGO_WIDTH = '8.875rem'; // 142px

export interface SignInLogoProps extends React.ComponentPropsWithRef<'div'> {
  /** Place content here. Pass in your custom logo here if necessary. */
  children?: React.ReactNode;
}

/** SignInLogo - Defaults to the Nokia logo, however you can pass your own. */
const SignInLogo = React.forwardRef<HTMLElement, SignInLogoProps>((props: SignInLogoProps, ref) =>
  getContext(({ RTL }) => {
    const { children, ...otherProps } = props;
    return (
      <Styled.SignInLogo $rtl={RTL} ref={ref} {...otherProps}>
        {children || <NokiaLogo style={{ width: LOGO_WIDTH, minWidth: LOGO_WIDTH }} />}
      </Styled.SignInLogo>
    );
  }));

SignInLogo.defaultProps = {
  children: undefined
};
SignInLogo.displayName = 'SignInLogo';

/* Exports */
export { SignInLogo as default };
